/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { AllasStandaloneSaveArticle as ResolvedStandaloneSaveArticle } from 'sites/allas/components/standalone/SaveArticle';

export const SaveArticle: typeof ResolvedStandaloneSaveArticle = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneSaveArticle {...props} />
    );
});

export type SaveArticleProps = PropsFromComponent<typeof SaveArticle>;

/** @deprecated Use slot architecture instead */
export const SaveArticleWith = (extras: DynamicStandaloneExtras): typeof SaveArticle => {
    return function SaveArticle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SaveArticle');
        return <ResolvedStandaloneSaveArticle {...mergeProps({ options: { theme } }, props)} />;
    }
}